// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css' 

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#335b98',
        secondary: '#29B6F6',
        accent: '#29B6F6',
        error: '#f44336',
        warning: '#ff9800',
        info: '#03a9f4',
        success: '#4caf50',
        anchor: '#335b98'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
